import {getToken, setToken, removeCookie} from './utils';
import appendQuery from 'append-query';

const getQueryToken = () =>
  (new URLSearchParams(document.location.search.substring(1))).get("token");


export default function registerAuthMiddleware(router) {
  let maybeForceUpdate = false;

  if (!getToken()) {
    setToken(getQueryToken() || "");
    maybeForceUpdate = true;
  }

  router.beforeEach((to, from, next) => {
    const toLogin = () => {
      window.location = appendQuery('https://account.superfluid.io/login', {callback: window.location.toString()});
      // window.location = appendQuery('http://localhost:5000/login', {callback: window.location.toString()});
      
      return next(false);
    };

    if (to.path === '/logout') {
      removeCookie();
      setToken("");
      return toLogin();
    }

    if (!getToken()) {
      return toLogin();
    }

    if (maybeForceUpdate) {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      return (next(false));
    }

    return next();
  });
}
